define([
    'jquery',
    './console'
], function($, console) {
    'use strict';

    let $slickEl;
    let slickSettings = {
        mobileFirst: true,
        // centerMode: true,
        // centerPadding: '10px',
        // slidesToShow: 3,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        // autoplaySpeed: 2000,
        // speed: 4000,
        prevArrow: '<button type="button" class="slick-prev"><span></span></button>',
        nextArrow: '<button type="button" class="slick-next"><span></span></button>'
        // dots: true,
        // responsive: [{
        //     breakpoint: 767,
        //     settings: "unslick"
        // }]
    };

    const init = function() {
        $slickEl = $('.js-gallery_images');

        initializeCarousel();
        $(window).on('resize', initializeCarousel);
    };

    const initializeCarousel = function() {
        console.log('window.width: ', $(window).width());

        if ($(window).width() > 767) {
            if ($slickEl.hasClass('slick-initialized')) {
                $slickEl.slick('unslick');
            }

            return;
        }

        if (!$slickEl.hasClass('slick-initialized')) {
            $slickEl.slick(slickSettings);
        }
    }

    return {
        init: init
    }
});